import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { ButtonBase } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { ViewTypes } from "../../../../Components";
import {
  ViewTypesEnum,
  ActionsButtonsEnum,
  SearchCriteriaEnum,
} from "../../../../Enums";
import { AdvanceSearchSecondVersion } from "../../../../SharedComponents/AdvanceSearchSecondVersion";
import { VendorsTableHeaderData } from "../VendorsUtilities";
import { GlobalAdvanceSearchActions } from "../../../../store/GlobalAdvanceSearch/GlobalAdvanceSearchActions";
import { GlobalOrderFilterActions } from "../../../../store/GlobalOrderFilter/GlobalOrderFilterActions";
import {
  generateUniqueKey,
  sideMenuComponentUpdate,
  sideMenuIsOpenUpdate,
} from "../../../../Helper";

export const VendorsAdvanceSearch = ({
  translationPath,
  parentTranslationPath,
  advanceSearch,
  setActiveActionType,
  activeActionType,
  onFilterValuesChanged,
  filterValuesFromAdvanceSearch,
  setOrderBy,
  formId,
  setFilterSearchDto,
  setVendorsTableFilter,
  setSelectedOrderBy,
  setIsAdvanceSearchActive,
  isAdvanceSearchActive,
  setFilterValuesFromAdvanceSearch,
  setActiveFormType,
  orderFilter,
  setActionButtonsKey,
  setIsClearFiltersClicked,
  dateRangeDefault,
  setSearchData,
  setSearchedItem,
  setDateFilter,
  activeSelectedAction,
  closeTypeDialogHandler,
  allFormFields,
  isAllFormFieldsLoading,
  selectFieldsOnAdvanceSearch,
  setSelectFieldsOnAdvanceSearch,
  setSelectedValuesInFilters,
  setContactClasses,
  setFilterValues,
  isAdvanceSearchCleared,
  setIsAdvanceSearchCleared,
  setVendorsContactClassesFilter,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation(parentTranslationPath);
  const [advanceSearchBtn, setAdvanceSearchBtn] = useState(true);

  const onTypeChanged = useCallback(
    (activeType) => {
      let ViewTypeData = JSON.parse(localStorage.getItem("ViewType"));

      if (ViewTypeData) {
        ViewTypeData.vendors = activeType;
        localStorage.setItem("ViewType", JSON.stringify(ViewTypeData));
      } else
        localStorage.setItem(
          "ViewType",
          JSON.stringify({ vendors: activeType })
        );

      setActiveActionType(activeType);
    },
    [setActiveActionType]
  );

  const searchAdvanceSearch = (newFilter) => {
    const searchObj = (newFilter && { ...newFilter }) || null;
    setVendorsTableFilter(searchObj);
    if (!(searchObj && searchObj.length)) {
      localStorage.removeItem("VendorsFilter");
    }
    dispatch(
      GlobalAdvanceSearchActions.globalAdvanceSearchRequest({
        ...advanceSearch,
        VendorsFilter: searchObj || null,
      })
    );
  };

  const changeActiveFormType = (value) => {
    if (value === 0 && activeSelectedAction === ActionsButtonsEnum[4].id) {
      closeTypeDialogHandler();
    }
    setActiveFormType(value);
    setSearchedItem("");
    dispatch(
      GlobalOrderFilterActions.globalOrderFilterRequest({
        ...orderFilter,
        activeFormType: value,
      })
    );
  };

  const onClearedAllFiltersClick = useCallback(() => {
    setSelectedOrderBy((item) => ({ ...item, filterBy: null, orderBy: null }));
    setOrderBy({ filterBy: "createdOn", orderBy: 2 });
    setSearchData([]);
    setDateFilter(dateRangeDefault);
    changeActiveFormType(0);
    setActiveFormType(0);
    setSearchedItem("");
    setIsClearFiltersClicked(true);
    setIsAdvanceSearchCleared(true);
    setSelectedValuesInFilters({
      Ids: null,
      mobile: null,
      agreementStatus: null,
      vendorCategory: null,
      city: null,
      country: null,
      companyName : null
    });
    setContactClasses([]);
    setVendorsContactClassesFilter([]);
    setVendorsTableFilter(null);
    setFilterSearchDto(null);
    sideMenuIsOpenUpdate(false);
    setIsAdvanceSearchActive(false);
    setFilterValuesFromAdvanceSearch([]);
    setSelectFieldsOnAdvanceSearch([]);
    setFilterValues({
      mobile: "",
      name: "",
      agreementStatus: null,
      vendorCategory: null,
      city: null,
      country: null,
      companyName : null
    });
    setActionButtonsKey(generateUniqueKey());
    dispatch(
      GlobalOrderFilterActions.globalOrderFilterRequest({
        ...orderFilter,
        activeFormType: 0,
        VendorsFilter: {
          filterBy: null,
          orderBy: null,
        },
        vendorContactClass: [],
      })
    );
    dispatch(
      GlobalAdvanceSearchActions.globalAdvanceSearchRequest({
        ...advanceSearch,
        VendorsFilter: null,
        vendorContactClass: [],
      })
    );
  }, []);

  const onAdvanceSearchClick = useCallback(
    (event) => {
      event.stopPropagation();
      event.preventDefault();
      if (advanceSearchBtn) {
        sideMenuIsOpenUpdate(true);
        setAdvanceSearchBtn(false);
      } else {
        sideMenuIsOpenUpdate(false);
        setAdvanceSearchBtn(true);
      }
      sideMenuComponentUpdate(
        <AdvanceSearchSecondVersion
          parentTranslationPath={parentTranslationPath}
          translationPath={translationPath}
          onFilterValuesChanged={onFilterValuesChanged}
          localStorageKey="VendorsFilter"
          isAdvanceSearchCleared={isAdvanceSearchCleared}
          setIsAdvanceSearchCleared={setIsAdvanceSearchCleared}
          setOrderBy={setOrderBy}
          searchCriteriaTypeId={SearchCriteriaEnum.Contact.typeId}
          setIsAdvanceSearchActive={setIsAdvanceSearchActive}
          fields={[...VendorsTableHeaderData(t).filter((i)=> i?.input !== 'vendorClass' )]}
          selectFieldsOnAdvanceSearch={selectFieldsOnAdvanceSearch}
          setSelectFieldsOnAdvanceSearch={setSelectFieldsOnAdvanceSearch}
          setFilterValuesFromAdvanceSearch={setFilterValuesFromAdvanceSearch}
          filterValuesFromAdvanceSearch={filterValuesFromAdvanceSearch}
          searchAdvanceSearch={searchAdvanceSearch}
        />
      );
    },
    [
      isAllFormFieldsLoading,
      allFormFields,
      advanceSearchBtn,
      isAdvanceSearchCleared,
      selectFieldsOnAdvanceSearch,
    ]
  );

  return (
    <div className="view-search-wrapper">
      <ViewTypes
        onTypeChanged={onTypeChanged}
        initialActiveType={activeActionType}
        activeTypes={[ViewTypesEnum.tableView.key, ViewTypesEnum.cards.key]}
        className="mb-3"
      />
      <span className="advance-search">
        <ButtonBase
          onClick={onAdvanceSearchClick}
          id="AdvanceSearch_bbt"
          disabled={isAllFormFieldsLoading}
          className={`btns theme-solid ${
            isAdvanceSearchActive &&
            !isAllFormFieldsLoading &&
            "is-active-filter"
          }`}
        >
          <span
            className={`${
              advanceSearchBtn
                ? "mdi mdi-arrow-expand-left"
                : "mdi mdi-arrow-expand-right"
            } mr-1`}
          />
          {t(`${translationPath}advance-search`)}
        </ButtonBase>
      </span>
      <ButtonBase
        onClick={onClearedAllFiltersClick}
        id="onClearedAllFiltersref"
        disabled={isAllFormFieldsLoading}
        className="btns theme-solid bg-danger clear-all-btn"
      >
        <span className="mdi mdi-filter-remove m-1" />
        {t(`${translationPath}clear-filters`)}
      </ButtonBase>
    </div>
  );
};
